import { render, staticRenderFns } from "./FormFillingPeriodMessage.vue?vue&type=template&id=1bc855c2&scoped=true&"
import script from "./FormFillingPeriodMessage.vue?vue&type=script&lang=js&"
export * from "./FormFillingPeriodMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc855c2",
  null
  
)

export default component.exports